import { bfsUserWebHttp, otmsHttp } from '@/utils/http/index';

/**
 * 租户树查询
 * https://yapi.ops.yunlizhi.cn/project/10/interface/api/13974
 */
export function getTenantTree(data) {
  return bfsUserWebHttp.post('/bfs-user/tenant/tree', data);
}

/**
 * 根据货主查询(货主配置)
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/cat_12560
 */
export function customerProcessRule(data) {
  return otmsHttp.post('/cms_plus/process_rule/customer/detail/list', data);
}

/**
 * 货主服务设置流程创建
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/23623
 */
export function customerProcessRuleCreate(data) {
  return otmsHttp.post('/cms_plus/process_rule/customer/create', data);
}

/**
 * 货主服务设置流程更新
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/23625
 */
export function customerProcessRuleUpdate(data) {
  return otmsHttp.post('/cms_plus/process_rule/customer/update', data);
}

/**
 * 获取配置
 */
export function getConfigList(data) {
  return otmsHttp.post('/config/query', data);
}

/**
 * 获取车型
 * https://yapi.ops.yunlizhi.cn/project/138/interface/api/717
 */
export function getCarType(data) {
  return otmsHttp.post('/tcs_plus/car/setting/list', data);
}

/**
 * 母单配置查询
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/45438
 */
export function parentMarkList(data) {
  return otmsHttp.post('/cms_plus/parent/mark/list', data);
}

/**
 * 母单配置(创建)
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/45444
 */
export function parentMarkCreate(data) {
  return otmsHttp.post('/cms_plus/parent/mark/create', data);
}

/**
 * 母单配置(删除)
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/45450
 */
export function parentMarkDelete(data) {
  return otmsHttp.post('/cms_plus/parent/mark/delete', data);
}

/**
 * 查询货主仓储流程详情配置
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/63227
 */
export function customerWarehouseRuleDetail(data) {
  return otmsHttp.post('/cms_plus/process_rule/customer/warehouse/detail', data);
}

/**
 * 模拟企业微信消息发送
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/99720
 */
export function sendWechatPreviewMessage(data) {
  return otmsHttp.post('/cms_plus/mock/enterprise/wechat/send', data);
}

/**
 * 获取AI模型配置
 * https://yapi.ops.yunlizhi.cn/project/571/interface/api/99720
 */
export function getAiModelList() {
  return otmsHttp.get('/oms_plus/ai_model_config/select');
}

/**
 * 获取AI模型配置详情
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/117439
 */
export function getAiConfigDetail(data) {
  return otmsHttp.post('/oms_plus/ai_model_config/search', data);
}

/**
 * 新增AI模型配置
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/117433
 */
export function upsertAiConfig(data) {
  return otmsHttp.post('/oms_plus/ai_model_config/upsert', data);
}

/**
 * 删除AI模型配置文件
 * https://yapi.ops.yunlizhi.cn/project/42/interface/api/117433
 */
export function deleteAiConfigFile(data) {
  return otmsHttp.post('/oms_plus/ai_model_config/delete_file', data);
}
